/* ── RT Cart JS ──────────────────────────────────────────────────
   1. Discount Progress Bar + Confetti + Popup
   2. Complete Your Build - Upsell
   Loaded globally from theme.liquid.
─────────────────────────────────────────────────────────────────*/

/* ══════════════════════════════════════════════════════════════
   1. DISCOUNT PROGRESS BAR
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STORAGE_KEY    = 'rt_disc_was_unlocked';
  var _debounceTimer = null;

  function getPrev() { try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch(e) { return false; } }
  function setPrev(v){ try { sessionStorage.setItem(STORAGE_KEY, v ? '1' : '0'); } catch(e) {} }

  /* ── Confetti ─────────────────────────────────────────────── */
  var _raf = null, _canvas = null, _ctx = null;
  var COLORS = ['#e8302a','#c5291e','#111','#333','#f5c842','#f0a500','#2e7d32','#43a047','#fff','#e8e8e6'];
  var DEG = Math.PI / 180; /* shared constant - avoids recomputing in draw loop */

  function getCanvas() {
    if (!_canvas) {
      _canvas = document.createElement('canvas');
      _canvas.setAttribute('aria-hidden','true');
      _canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:99999;display:block';
      document.body.appendChild(_canvas);
      _ctx = _canvas.getContext('2d');
    }
    return _canvas;
  }

  function makePiece(W) {
    var a = (-90+(Math.random()-0.5)*140)*Math.PI/180, s=4+Math.random()*8;
    return { x:W*0.1+Math.random()*W*0.8, y:-10-Math.random()*20, vx:Math.cos(a)*s, vy:Math.sin(a)*s, w:6+Math.random()*8, h:3+Math.random()*5, col:COLORS[0|Math.random()*COLORS.length], rot:Math.random()*360, rv:(Math.random()-0.5)*12, op:1, g:0.18+Math.random()*0.12 };
  }

  function fireConfetti() {
    var cv = getCanvas();
    var dpr = window.devicePixelRatio || 1;
    var W = window.innerWidth, H = window.innerHeight;
    cv.width = W * dpr; cv.height = H * dpr;
    /* CSS already sets width:100vw; height:100vh on this canvas - no inline
       style override needed (and it would fight the vw/vh values on resize). */
    cv.style.willChange = 'transform';
    if (_raf) { cancelAnimationFrame(_raf); _raf=null; }
    /* cv.width= resets context state - no ctx.scale needed; DPR baked into
       each setTransform call instead (avoids stale scale on re-fire). */
    _ctx.clearRect(0, 0, cv.width, cv.height);
    var pp=[], t0=null;
    for(var i=0;i<120;i++) pp.push(makePiece(W));
    function draw(ts){
      if(!t0) t0=ts;
      /* Reset to DPR-scale for clearRect, then setTransform per piece.
         setTransform replaces save+translate+rotate+restore - 4 calls → 1.
         For 120 pieces: 480 state push/pop ops per frame → 120 matrix sets. */
      _ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      _ctx.clearRect(0, 0, W, H);
      var alive=false;
      for(var i=0;i<pp.length;i++){
        var p=pp[i]; p.vy+=p.g; p.vx*=0.99; p.vy*=0.99; p.x+=p.vx; p.y+=p.vy; p.rot+=p.rv;
        if(p.y>H*0.7) p.op-=0.018;
        if(p.x<-20||p.x>W+20) p.op=0;
        if(p.op<=0) continue;
        alive=true;
        var rads=p.rot*DEG, cos=Math.cos(rads), sin=Math.sin(rads);
        _ctx.setTransform(cos*dpr, sin*dpr, -sin*dpr, cos*dpr, p.x*dpr, p.y*dpr);
        _ctx.globalAlpha=Math.max(0,p.op);
        _ctx.fillStyle=p.col;
        _ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h);
      }
      if(alive){
        _raf=requestAnimationFrame(draw);
      } else {
        _raf=null;
        _ctx.setTransform(1,0,0,1,0,0);
        _ctx.clearRect(0,0,cv.width,cv.height);
        cv.style.willChange='';
      }
    }
    /* Skip one frame before starting the draw loop.
       cv.style.willChange promotion and GPU texture allocation from cv.width=
       are async - the browser completes them in the next paint cycle.
       Drawing on frame 0 hits an un-promoted layer → hitch on first frame. */
    requestAnimationFrame(function() { _raf = requestAnimationFrame(draw); });
  }

  /* ── Popup ────────────────────────────────────────────────── */
  var _popTimer = null;
  function showPopup() {
    var p = document.getElementById('rt-unlock-popup');
    if (!p) return;
    clearTimeout(_popTimer);
    p.classList.remove('rt-popup--in','rt-popup--out');
    void p.offsetWidth;
    p.classList.add('rt-popup--in');
    _popTimer = setTimeout(function(){
      p.classList.remove('rt-popup--in');
      p.classList.add('rt-popup--out');
    }, 3500);
  }

  /* ── Update step UI after Ajax ────────────────────────────── */
  function updateSteps(qty, threshold, unlocked) {
    var bar = document.getElementById('rt-ship-bar');
    if (!bar) return;

    var checkSVG = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var discSVG  = '<svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M3 8L8 3M3.8 3.5H3.3M7.7 7.5H7.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><circle cx="3.8" cy="3.8" r="1.1" stroke="currentColor" stroke-width="1.2"/><circle cx="7.2" cy="7.2" r="1.1" stroke="currentColor" stroke-width="1.2"/></svg>';

    var defs = [
      { done: qty>=1, active: qty===1 && !unlocked, label:'1 item',  icon: qty>=1 ? checkSVG : '1' },
      { done: qty>=2, active: qty===2 && !unlocked, label:'2 items', icon: qty>=2 ? checkSVG : '2' },
      { done: unlocked, active: false, label: unlocked ? '3% off!' : '3% off', icon: unlocked ? checkSVG : discSVG }
    ];

    bar.querySelectorAll('.rt-ship-bar__step').forEach(function(step, i) {
      var d   = defs[i];
      var cls = 'rt-ship-bar__step';
      if (unlocked)      cls += ' rt-ship-bar__step--unlocked';
      else if (d.done)   cls += ' rt-ship-bar__step--done';
      else if (d.active) cls += ' rt-ship-bar__step--active';
      step.className = cls;
      var circle = step.querySelector('.rt-ship-bar__step-circle');
      if (circle) circle.innerHTML = d.icon;
      var label = step.querySelector('.rt-ship-bar__step-label');
      if (label) label.textContent = d.label;
    });

    var lineDefs = [
      { done: qty>=2,   active: qty===1 && !unlocked, unlocked: unlocked },
      { done: unlocked, active: qty===2 && !unlocked, unlocked: unlocked }
    ];
    bar.querySelectorAll('.rt-ship-bar__step-line').forEach(function(line, i) {
      var d   = lineDefs[i];
      var cls = 'rt-ship-bar__step-line';
      if (d.unlocked)    cls += ' rt-ship-bar__step-line--unlocked';
      else if (d.done)   cls += ' rt-ship-bar__step-line--done';
      else if (d.active) cls += ' rt-ship-bar__step-line--active';
      line.className = cls;
    });

    bar.classList.toggle('rt-ship-bar--unlocked', unlocked);

    var msg  = bar.querySelector('.rt-ship-bar__msg');
    var need = threshold - qty;
    if (msg) {
      msg.innerHTML = unlocked
        ? '<strong>3% off unlocked!</strong> Your discount is applied at checkout \u2014 nice build.'
        : 'Add <strong>' + need + ' more item' + (need > 1 ? 's' : '') + '</strong> to your order and unlock <strong>3% off everything</strong>';
    }

    var icon = bar.querySelector('.rt-ship-bar__icon');
    if (icon) {
      icon.innerHTML = unlocked
        ? '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5 7-7" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M3.5 9.5L9.5 3.5M4.5 4H4M9 9h-.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="4.5" cy="4.5" r="1.3" stroke="currentColor" stroke-width="1.2"/><circle cx="8.5" cy="8.5" r="1.3" stroke="currentColor" stroke-width="1.2"/></svg>';
    }

    var badge = bar.querySelector('.rt-ship-bar__milestones span:last-child');
    if (badge) {
      badge.innerHTML = unlocked
        ? '<span class="rt-ship-bar__badge">3% off applied \u2713</span>'
        : '3 items = 3% off';
    }

    bar.dataset.qtyCurrent = qty;
  }

  /* ── Core check ───────────────────────────────────────────── */
  function check(isPageLoad) {
    var bar = document.getElementById('rt-ship-bar');
    if (!bar) return;
    var qty          = parseInt(bar.dataset.qtyCurrent,   10) || 0;
    var threshold    = parseInt(bar.dataset.qtyThreshold, 10) || 3;
    var nowUnlocked  = qty >= threshold;
    var prevUnlocked = getPrev();
    if (isPageLoad) {
      if (nowUnlocked) {
        /* RT FIX: was firing at setTimeout(600) from DOMContentLoaded - right
           in the middle of render-blocking CSS/JS parsing and first paint.
           Canvas draw loop competing with page rendering = guaranteed stutter.
           Now waits for window.load (all resources parsed + painted) then adds
           a short grace period for layout to settle before starting the loop. */
        var afterLoad = function() {
          setTimeout(fireConfetti, 400);
          setTimeout(showPopup,   600);
        };
        if (document.readyState === 'complete') {
          afterLoad(); /* page already loaded (e.g. back-navigation cache) */
        } else {
          window.addEventListener('load', afterLoad, { once: true });
        }
      }
    } else {
      /* Live cart update - page is already loaded, fire immediately */
      updateSteps(qty, threshold, nowUnlocked);
      if (!prevUnlocked && nowUnlocked) { setTimeout(fireConfetti, 200); setTimeout(showPopup, 380); }

    }
    setPrev(nowUnlocked);
  }

  function onCartUpdate() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function(){ check(false); }, 80);
  }

  function boot() {
    if (!document.getElementById('rt-ship-bar')) return;
    check(true);
    window.addEventListener('semanticInput', onCartUpdate);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

})();


/* ══════════════════════════════════════════════════════════════
   2. COMPLETE YOUR BUILD - UPSELL
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function money(cents) {
    return '\u20b9' + Math.round(cents / 100).toLocaleString('en-IN');
  }
  /* HTML-escape values interpolated into innerHTML from live product JSON */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function checkSVG() {
    return '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.5 6l3 3 6-6" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function plusSVG() {
    return '<svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  }
  /* Arrow icon for "View options" button */
  function arrowSVG() {
    return '<svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 5.5h7M6 2.5l3 3-3 3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function badgeHTML(p) {
    var hasDiscount = p.compare_at_price_min && p.compare_at_price_min > p.price_min;
    if (hasDiscount) return '<span class="rt-upsell__card-badge rt-upsell__card-badge--sale">Sale</span>';
    var tags = (p.tags || []).map(function(t){ return t.toLowerCase(); });
    if (tags.indexOf('new') > -1)     return '<span class="rt-upsell__card-badge rt-upsell__card-badge--new">New</span>';
    if (tags.indexOf('popular') > -1) return '<span class="rt-upsell__card-badge rt-upsell__card-badge--popular">Popular</span>';
    return '';
  }

  function cardHTML(p) {
    var isSingle  = p.variants && p.variants.length === 1;
    var variantId = isSingle ? p.variants[0].id : '';
    var available = p.variants && p.variants.some(function(v){ return v.available; });

    var imgHTML = p.featured_image
      ? '<img src="' + p.featured_image + '&width=324" alt="' + p.title.replace(/"/g,'&quot;') + '" loading="lazy" width="162" height="162">'
      : '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="6" y="14" width="36" height="22" rx="4" fill="#d8d8d4"/><circle cx="14" cy="38" r="5" fill="#c4c4c0"/><circle cx="34" cy="38" r="5" fill="#c4c4c0"/></svg>';

    var hasDiscount = p.compare_at_price_min && p.compare_at_price_min > p.price_min;
    var savePct     = hasDiscount ? Math.round((1 - p.price_min / p.compare_at_price_min) * 100) : 0;
    var wasHTML     = hasDiscount ? '<span class="rt-upsell__card-was">' + money(p.compare_at_price_min) + '</span>' : '';
    var saveHTML    = hasDiscount ? '<span class="rt-upsell__card-saving">\u2212' + savePct + '%</span>' : '';

    var btnHTML;
    if (!available) {
      /* Out of stock - grey disabled button */
      btnHTML = '<button class="rt-upsell__card-btn rt-upsell__card-btn--ooo" disabled>Out of stock</button>';
    } else if (isSingle) {
      /* Single variant - Ajax add to cart */
      btnHTML = '<button class="rt-upsell__card-btn rt-upsell__card-btn--atc"'
        + ' data-variant-id="' + variantId + '" data-single="1"'
        + ' aria-label="Add ' + p.title.replace(/"/g,'&quot;') + ' to cart">'
        + plusSVG() + ' Add to cart'
        + '</button>';
    } else {
      /* Multi-variant - styled as a link-button, opens PDP in same tab */
      btnHTML = '<a class="rt-upsell__card-btn rt-upsell__card-btn--opts" href="' + p.url + '">'
        + arrowSVG() + ' View options'
        + '</a>';
    }

    return '<div class="rt-upsell__card' + (hasDiscount ? ' rt-upsell__card--featured' : '') + '">'
      + '<div class="rt-upsell__card-img-wrap">'
      + badgeHTML(p)
      + '<a href="' + p.url + '" class="rt-upsell__card-img-inner">' + imgHTML + '</a>'
      + '</div>'
      + '<div class="rt-upsell__card-body">'
      + '<div class="rt-upsell__card-vendor">' + esc(p.vendor || '') + '</div>'
      + '<div class="rt-upsell__card-name"><a href="' + p.url + '">' + esc(p.title) + '</a></div>'
      + '<div class="rt-upsell__card-prices">'
      + '<span class="rt-upsell__card-price">' + money(p.price_min) + '</span>'
      + wasHTML + saveHTML
      + '</div>'
      + '</div>'
      + btnHTML
      + '</div>';
  }

  function bindButtons(grid) {
    /* Only bind click handlers for single-variant ATC buttons.
       Multi-variant buttons are plain <a> tags - browser handles navigation natively. */
    grid.querySelectorAll('.rt-upsell__card-btn--atc').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var original = btn.innerHTML;
        btn.innerHTML = 'Adding\u2026';
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.75';

        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data.status) {
            /* Sold out / error */
            btn.classList.remove('rt-upsell__card-btn--atc');
            btn.classList.add('rt-upsell__card-btn--ooo');
            btn.innerHTML = 'Out of stock';
            btn.style.opacity = '1';
            btn.disabled = true;
            return;
          }
          btn.classList.add('rt-upsell__card-btn--added');
          btn.innerHTML = checkSVG() + ' Added';
          btn.style.opacity = '1';
          /* Reload so cart totals, discount bar, and item list all update */
          setTimeout(function(){ window.location.reload(); }, 600);
        })
        .catch(function(){
          btn.innerHTML = original;
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
        });
      });
    });
  }

  function renderCards(products, grid, cartProductIds) {
    var filtered = products.filter(function(p){
      return cartProductIds.indexOf(p.id) === -1;
    }).slice(0, 8);

    var wrap = document.getElementById('rt-upsell-wrap');
    if (!filtered.length) { if (wrap) wrap.style.display = 'none'; return; }

    grid.innerHTML = filtered.map(cardHTML).join('');

    var countEl = document.getElementById('rt-upsell-count');
    if (countEl) {
      countEl.textContent = filtered.length + ' product' + (filtered.length !== 1 ? 's' : '');
      countEl.style.display = 'inline';
    }

    bindButtons(grid);
  }

  function loadUpsell() {
    var wrap = document.getElementById('rt-upsell-wrap');
    var grid = document.getElementById('rt-upsell-grid');
    if (!wrap || !grid) return;

    var productId = wrap.dataset.productId;
    if (!productId) return;

    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var cartProductIds = cart.items.map(function(i){ return i.product_id; });

        var fetches = cart.items.map(function(item){
          return fetch('/recommendations/products.json?product_id=' + item.product_id + '&limit=10&intent=complementary')
            .then(function(r){ return r.json(); })
            .then(function(d){ return d.products || []; })
            .catch(function(){ return []; });
        });

        Promise.all(fetches).then(function(results){
          var seen = {}, merged = [];
          results.forEach(function(prods){
            prods.forEach(function(p){
              if (!seen[p.id] && cartProductIds.indexOf(p.id) === -1) {
                seen[p.id] = true;
                merged.push(p);
              }
            });
          });

          if (merged.length > 0) { renderCards(merged, grid, cartProductIds); return; }

          /* Fallback: related intent until complementary is configured in Shopify admin */
          fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
            .then(function(r){ return r.json(); })
            .then(function(d){ renderCards(d.products || [], grid, cartProductIds); })
            .catch(function(){ if (wrap) wrap.style.display = 'none'; });
        });
      })
      .catch(function(){ if (wrap) wrap.style.display = 'none'; });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', loadUpsell); }
  else { loadUpsell(); }

  /* RT FIX (INP): debounce cart-update rebuilds - avoids per-keystroke qty
     refetch + full innerHTML rebuild while the user is still interacting. */
  var _upsellT;
  window.addEventListener('semanticInput', function(){ clearTimeout(_upsellT); _upsellT = setTimeout(loadUpsell, 400); });

})();
/* ── End RT Cart JS ──────────────────────────────────────────────*/